import { Route, Router } from "@angular/router";

import { pmoEntity } from "../../core/guards";
import { SubmenuComponent } from "../../shared/components";
import { PageMode } from "../../shared/constants/enums";
import {
  createGovernmentScoresPageGuards,
  manageGovernmentScoresPageGuards,
  manageStrategyDashboardPageGuards,
  viewGovernmentScoresPageGuards,
} from "./_guards";
import { EntityPillarsEditorComponent } from "./entity-pillars/entity-pillars-editor/entity-pillars-editor";
import { EntityPillarsListComponent } from "./entity-pillars/entity-pillars-list/entity-pillars-list";
import { EntityPillarsTypesEditorComponent } from "./entity-pillars-types/entity-pillars-types-editor/entity-pillars-types-editor";
import { EntityPillarsTypesListComponent } from "./entity-pillars-types/entity-pillars-types-list/entity-pillars-types-list";
import { GovernmentSectorsEditorComponent } from "./government-sectors/government-sectors-editor/government-sectors-editor";
import { GovernmentSectorsListComponent } from "./government-sectors/government-sectors-list/government-sectors-list";
import { StrategyDashboardManagementComponent } from "./strategy-dashboard-management/strategy-dashboard-management";
import { StructureNavigationComponent } from "./structure-navigation/structure-navigation";

const sectorsRoutes: Route = {
  path: "sectors",
  children: [
    {
      path: "",
      component: GovernmentSectorsListComponent,
      data: {
        breadcrumb: "government_scores.government_sectors",
        title: "government_scores.government_sectors",
      },
    },
    {
      path: "create",
      component: GovernmentSectorsEditorComponent,
      canActivate: [...createGovernmentScoresPageGuards],
      data: {
        breadcrumb: "government_scores.sectors.create",
        title: "government_scores.sectors.create",
        pageMode: PageMode.create,
      },
    },
    {
      path: "edit/:id",
      component: GovernmentSectorsEditorComponent,
      canActivate: [...manageGovernmentScoresPageGuards],
      data: {
        breadcrumb: "government_scores.sectors.edit",
        title: "government_scores.sectors.edit",
        pageMode: PageMode.edit,
      },
    },
    {
      path: ":id",
      component: GovernmentSectorsEditorComponent,
      data: {
        breadcrumb: "government_scores.sectors.view",
        title: "government_scores.sectors.view",
        pageMode: PageMode.view,
      },
    },
  ],
};

const entityPillarsRoutes: Route = {
  path: "pillars-types",
  children: [
    {
      path: "",
      component: EntityPillarsTypesListComponent,
      data: {
        breadcrumb: "government_scores.entity_pillars",
        title: "government_scores.entity_pillars",
      },
    },
    {
      path: "create",
      component: EntityPillarsTypesEditorComponent,
      canActivate: [...createGovernmentScoresPageGuards],
      data: {
        breadcrumb: "government_scores.pillars.create",
        title: "government_scores.pillars.create",
        pageMode: PageMode.create,
      },
    },
    {
      path: "edit/:id",
      component: EntityPillarsTypesEditorComponent,
      canActivate: [...manageGovernmentScoresPageGuards],
      data: {
        breadcrumb: "government_scores.pillars.edit",
        title: "government_scores.pillars.edit",
        pageMode: PageMode.edit,
      },
    },
    {
      path: ":id",
      component: EntityPillarsTypesEditorComponent,
      data: {
        breadcrumb: "government_scores.pillars.view",
        title: "government_scores.pillars.view",
        pageMode: PageMode.view,
      },
    },
  ],
};

const scopesRoutes: Route = {
  path: "entity-pillars",
  children: [
    {
      path: "",
      component: EntityPillarsListComponent,
      data: {
        breadcrumb: "government_scores.scopes.title",
        title: "government_scores.scopes.title",
      },
    },
    {
      path: "create",
      component: EntityPillarsEditorComponent,
      canActivate: [...createGovernmentScoresPageGuards],
      data: {
        breadcrumb: "government_scores.scopes.create",
        title: "government_scores.scopes.create",
        pageMode: PageMode.create,
      },
    },
    {
      path: "edit/:id",
      component: EntityPillarsEditorComponent,
      canActivate: [...manageGovernmentScoresPageGuards],
      data: {
        breadcrumb: "government_scores.scopes.edit",
        title: "government_scores.scopes.edit",
        pageMode: PageMode.edit,
      },
    },
    {
      path: ":id",
      component: EntityPillarsEditorComponent,
      data: {
        breadcrumb: "government_scores.scopes.view",
        title: "government_scores.scopes.view",
        pageMode: PageMode.view,
      },
    },
  ],
};

const structureNavigationRoutes: Route = {
  path: "navigation",
  component: StructureNavigationComponent,
  canActivate: [...viewGovernmentScoresPageGuards],
  data: {
    breadcrumb: "government_scores.structure_navigation",
    title: "government_scores.structure_navigation",
  },
};

const strategyDashboardManagementRoutes: Route = {
  path: "strategy-dashboard-management",
  component: StrategyDashboardManagementComponent,
  canActivate: [...manageStrategyDashboardPageGuards, pmoEntity],
  data: {
    breadcrumb: "government_scores.strategy_dashboard_management.title",
    title: "government_scores.strategy_dashboard_management.title",
  },
};

export const GOVERNMENT_SCORES_ROUTES: Route[] = [
  {
    path: "government-scores",
    canActivate: [...viewGovernmentScoresPageGuards, pmoEntity],
    children: [
      {
        path: "",
        component: SubmenuComponent,
        data: {
          breadcrumb: "government_scores.page_title",
          title: "government_scores.page_title",
          onEntityChange: (router: Router) => router.navigateByUrl("console"),
        },
      },
      sectorsRoutes,
      entityPillarsRoutes,
      scopesRoutes,
      structureNavigationRoutes,
      strategyDashboardManagementRoutes,
    ],
  },
];
